import type { History, Location } from 'history';
import { eventChannel, buffers, Subscribe } from 'redux-saga';

export function createRouterChannel(
  service: History,
  buffer = buffers.none<Location>()
) {
  const subscribe: Subscribe<Location> = (emitter) => service.listen(emitter); // return unsubscribe listening function

  return eventChannel(subscribe, buffer);
}
